import {
  BRAND_PRINCIPLES_HERO_SLIDES,
  PRO_SCREEN_OVERVIEW_SLIDES,
} from "./Overview.config";
import { OverviewPage } from "components/OverviewPage/OverviewPage";
import { useTranslation } from "hooks/useTranslation";
import { WIFI_FEATURE_OVERVIEW_TILES } from "../config/Features.config";
import Head from "layout/Head";
import React, { Fragment, useMemo } from "react";
import { WifiOverview } from "@ubnt/store.core/lib/constants/modelCompareData/data/WiFiOverview";
import { useMicrositeProductPage } from "@ubnt/store.core/lib/components/Microsites/context/MicrositeProductPageContext";
import { useSiteSettings } from "context/SiteSettingsContext";

export const Overview = () => {
  const { t } = useTranslation();
  const { routes } = useSiteSettings();
  const { showBuyButton } = useMicrositeProductPage();

  const faq = useMemo(() => {
    return {
      1: {
        id: 1,
        title: t("wifi.overview.faq.question1"),
        answer: t("wifi.overview.faq.answer1.1", {
          link1: `<a href="${routes.uiComPage({
            path: "/cloud-gateways",
          })}">UniFi Cloud Gateway</a>`,
        }),
      },
      2: {
        id: 2,
        title: t("wifi.overview.faq.question2"),
        answer: t("wifi.overview.faq.answer2.1", {
          link1: `<a href="https://help.ui.com/hc/en-us/articles/4416276882327">${t("wifi.overview.faq.unifiSetup")}</a>`,
          link2: `<a href="https://apps.apple.com/us/app/unifi/id1057750338">iOS</a>`,
          link3: `<a href="https://play.google.com/store/apps/details?id=com.ubnt.easyunifi&hl=en_US&gl=US&pli=1">Android</a>`,
          link4: `<a href="http://unifi.ui.com">UniFi Site Manager</a>`,
          link5: `<a href="https://help.ui.com/hc/en-us/articles/360012622613">${t("wifi.overview.faq.adopt")}</a>`,
          link6: `<a href="${routes.uiComPage({
            path: "/switching",
          })}">UniFi PoE Switch</a>`,
          link8: `<a href="${routes.uiComPage({
            path: "/cloud-gateways",
          })}">UniFi Cloud Gateway</a>`,
        }),
      },
      3: {
        id: 3,
        title: t("wifi.overview.faq.question3"),
        answer: t("wifi.overview.faq.answer3.1", {
          link0: `<strong><a href="${routes.uiComPage({
            path: "/wifi/enterprise",
          })}">Enterprise</a></strong>`,
          link1: `<strong><a href="${routes.uiComPage({
            path: "/wifi/flagship",
          })}">Flagship</a></strong>`,
          link2: `<strong><a href="${routes.uiComPage({
            path: "/wifi/wall",
          })}">Wall</a></strong>`,
          link3: `<strong><a href="${routes.uiComPage({
            path: "/wifi/outdoor",
          })}">Outdoor</a></strong>`,
          link5: `<strong><a href="${routes.uiComPage({
            path: "/wifi/bridging",
          })}">Bridging</a></strong>`,
        }),
      },
      4: {
        id: 4,
        title: t("wifi.overview.faq.question4"),
        answer: t("wifi.overview.faq.answer4"),
      },
      5: {
        id: 5,
        title: t("wifi.overview.faq.question5"),
        answer: t("wifi.overview.faq.answer5.1", {
          link1: `<a href="${routes.uiComPage({
            path: "/switching",
          })}">UniFi PoE Switch</a>`,
          link3: `<a href="https://help.ui.com/hc/en-us/articles/115000263008">PoE Mode</a>`,
        }),
      },
      6: {
        id: 6,
        title: t("wifi.overview.faq.question6"),
        answer: t("wifi.overview.faq.answer6.1"),
      },
      7: {
        id: 7,
        title: t("wifi.overview.faq.question7.1"),
        answer: t("wifi.overview.faq.answer7"),
      },
      8: {
        id: 8,
        title: t("wifi.overview.faq.question8"),
        answer: t("wifi.overview.faq.answer8"),
      },
    };
  }, [t, routes]);

  return (
    <Fragment>
      <Head
        title={t("wifi.seo.title")}
        description={t("wifi.seo.description")}
        url="https://ui.com/wifi"
        image="https://www.ui.com/microsite/og-image.wifi.jpg?v=2"
      />

      <OverviewPage
        brandPrinciples={BRAND_PRINCIPLES_HERO_SLIDES}
        featureConfig={WIFI_FEATURE_OVERVIEW_TILES}
        compare={{
          section: WifiOverview,
          showBuyButton: showBuyButton,
          title: t("wifi.overview.compare.title"),
          description: t("wifi.overview.compare.description"),
        }}
        faq={{
          list: faq,
          link: {
            title: t("commons.visitHelpUiCom"),
            url: "https://help.ui.com/hc/en-us/categories/6583256751383",
          },
        }}
        heroSections={{
          title: t("screens.wifi.title"),
          slides: PRO_SCREEN_OVERVIEW_SLIDES,
        }}
      />
    </Fragment>
  );
};
